<template>
  <div v-if="prev || next || oneTimeAccess" :class="{ 'bottom-buttons': !top }">
    <div class="row">
      <div class="col-md-4" style="text-align: center;">
        <router-link tag="a" :to="{ name: prev }">
          <div class="nav-button" v-if="prev">
            &#x2190; Prev
          </div>
        </router-link>
      </div>

      <div class="col-md-4" style="text-align: center;">
        <button
          v-if="!top"
          type="submit"
          style="background: none; border: none;"
          tag="a"
        >
          <div class="btn btn-create">
            <i class="fa fa-save"></i> &nbsp;Save
          </div>
        </button>
      </div>

      <div class="col-md-4" style="text-align: center;">
        <router-link tag="a" :to="{ name: next }">
          <div class="nav-button" v-if="next && newProviderPosted">
            Next &#x2192;
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "buttons",
  props: {
    top: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      authenticated: "authenticated",
      newProviderPosted: "newProviderPosted",
      next: "next",
      prev: "prev",
      isCreateMode: "isCreateMode",
      isNullMode: "isNullMode",
      noErrors: "noErrors",
      verifySync: "verifySync",
      isCreateMode: "isCreateMode",
      getProperty: "getEditedProviderValueByKeyChain",
      oneTimeAccess: "oneTimeAccess"
    })
  }
};
</script>

<style scoped>
.bottom-container {
  position: fixed;
  left: 0;
  bottom: 0px;
  width: 100%;
  color: white;
  text-align: center;
  z-index: 9999;
}

.nav-button {
  display: inline-block;
  padding: 5px 15px 5px 15px;
  margin-left: 13px;
  margin-right: 13px;
  border: solid 1px white;
  font-size: 16px;
  border-radius: 5px;
  background-color: white;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
  /* background-color:#2d3f4f; */
  /* color: white; */
}

.nav-button:hover {
  color: #32a6ae;
}

.left-button {
  float: left;
}

.right-button {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/elements/buttons.vue